import { Component, Input } from '@angular/core';
import { SectionStatus } from '../../../pages/profile-review-attest/section-status.util';

@Component({
  standalone: false,
  selector: 'agmo-status-pill',
  templateUrl: './status-pill.component.html',
  styleUrls: ['./status-pill.component.scss'],
})
export class StatusPillComponent {
  @Input() status: SectionStatus;

  get statusLabel(): string {
    switch (this.status) {
      case 'ok':
        return 'Complete';
      case 'needsChange':
        // Informational, non-blocking state: no pill. The section still shows
        // its data + Edit button, so an investor can fix it if they want, but
        // we don't nag with a "Please review" label.
        return '';
      case 'missing':
        return 'Info needed';
      case 'reverify':
        return 'Verification pending';
      default:
        return '';
    }
  }
}
